import { AxiosResponse } from 'axios';
import { Observable, from } from 'rxjs/';
import { map } from 'rxjs/operators';
import { http } from '../../http.client';
import { Page } from '../../models/page';
import { defaultPageRequest, PageRequest } from '../../models/page.request';

export class CommonMasterService {
  readonly COMMAND_CONTEXT = `/master-data-service/v1/common_master/all`;
  readonly COMMAND_ORG = `/organization-query-service/v1/hms-org`;
  readonly QUOTATION_QUERY = `/quotation-query-service/v1/quotationsGmc`;
  readonly DOWNLOAD_TEMPLATE = `/quotation-query-service/new-gmc/template/download`;
  readonly QUERY_CONTEXT = `/benefit-structure-query-service/v1/benefitstructures`;

  getRateChartType(): Observable<Page<any>> {
    return http
      .post<Page<any>>(`${this.COMMAND_CONTEXT}`, {
        page: 0,
        size: 1000,
        commonTypeDesc: 'CHART_TYPE',
      })
      .pipe(map((response: AxiosResponse<Page<any>>) => response.data));
  }

  getPolicyType(): Observable<Page<any>> {
    return http
      .post<Page<any>>(`${this.COMMAND_CONTEXT}`, {
        page: 0,
        size: 1000,
        commonTypeDesc: 'POLICY_TYPE',
      })
      .pipe(map((response: AxiosResponse<Page<any>>) => response.data));
  }
  getPolicyIssuanceType(): Observable<Page<any>> {
    return http
      .post<Page<any>>(`${this.COMMAND_CONTEXT}`, {
        page: 0,
        size: 1000,
        commonTypeDesc: 'ISSUANCE_TYPE',
      })
      .pipe(map((response: AxiosResponse<Page<any>>) => response.data));
  }
  getTPAType(): Observable<Page<any>> {
    return http
      .get<Page<any>>(`${this.COMMAND_ORG}`, {
        params: {
          page: 0,
          size: 1000,
          orgType: 'TPA',
        },
      })
      .pipe(map((response: AxiosResponse<Page<any>>) => response.data));
  }

  getCorporateType(): Observable<Page<any>> {
    return http
      .get<Page<any>>(`${this.COMMAND_ORG}`, {
        params: {
          page: 0,
          size: 1000,
          orgType: 'Corporate',
        },
      })
      .pipe(map((response: AxiosResponse<Page<any>>) => response.data));
  }
  //   getCorporateType(): Observable<Page<any>> {
  //   return http
  //     .get<Page<any>>(`${this.COMMAND_ORG}`, {
  //       params: {
  //         page: 0,
  //         size: 1000,
  //         orgType: 'Corporate',
  //       },
  //     })
  //     .pipe(map((response: AxiosResponse<Page<any>>) => response.data));
  // }
  getCustomerSegment(): Observable<Page<any>> {
    return http
      .post<Page<any>>(`${this.COMMAND_CONTEXT}`, {
        page: 0,
        size: 1000,
        commonTypeDesc: 'CUSTOMER_SEGMENT',
      })
      .pipe(map((response: AxiosResponse<Page<any>>) => response.data));
  }
  getQuoteType(): Observable<Page<any>> {
    return http
      .post<Page<any>>(`${this.COMMAND_CONTEXT}`, {
        page: 0,
        size: 1000,
        commonTypeDesc: 'QUOTE_TYPE',
      })
      .pipe(map((response: AxiosResponse<Page<any>>) => response.data));
  }
  getClaimBeneficiery(): Observable<Page<any>> {
    return http
      .post<Page<any>>(`${this.COMMAND_CONTEXT}`, {
        page: 0,
        size: 1000,
        commonTypeDesc: 'CLAIM_BENEFICIARY',
      })
      .pipe(map((response: AxiosResponse<Page<any>>) => response.data));
  }

  downloadTemplate(payload: any): Observable<AxiosResponse<Blob>> {
    return from(
      http.post<Blob>(this.DOWNLOAD_TEMPLATE, payload, {
        responseType: 'blob',
      }),
    );
  }
}
